import { Box, Skeleton } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var LoadingProfilePopover = function LoadingProfilePopover() {
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row'
    },
    "data-element": "Box",
    "data-component": "LoadingProfilePopover",
    "data-source-file": "loading.tsx",
    children: [/*#__PURE__*/_jsx(Skeleton, {
      variant: "circular",
      width: 64,
      height: 64,
      "data-element": "Skeleton",
      "data-component": "LoadingProfilePopover",
      "data-source-file": "loading.tsx"
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        width: 200,
        ml: 2
      },
      "data-element": "Box",
      "data-source-file": "loading.tsx",
      children: [/*#__PURE__*/_jsx(Skeleton, {
        width: "60%",
        height: 36,
        "data-element": "Skeleton",
        "data-source-file": "loading.tsx"
      }), /*#__PURE__*/_jsx(Skeleton, {
        width: "100%",
        height: 24,
        "data-element": "Skeleton",
        "data-source-file": "loading.tsx"
      }), /*#__PURE__*/_jsx(Skeleton, {
        width: "100%",
        height: 24,
        "data-element": "Skeleton",
        "data-source-file": "loading.tsx"
      })]
    })]
  });
};

export default LoadingProfilePopover;